import React from 'react';
import TextFieldComponent from 'components/library/TextField';
import MaterialUiField from '../MaterialUiField';

const PasswordField = props => (
  <MaterialUiField {...props} muiComponent={TextFieldComponent} type="password" defaultValue="" />
);

export default PasswordField;
